import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PriceTag from '../PriceTag/PriceTag'
import { CalculatorContext } from '../Context/CalculatorContext'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    label: {
        display: 'inline'
    }
}))

const GroupCostLine = ({ label, total }) => {
    const classes = useStyles()
    const { currency } = useContext(CalculatorContext)
    return (
        <div className={classes.root}>
            <Typography
                variant={'body1'}
                color={'textPrimary'}
                className={classes.label}
            >
                {label}
            </Typography>
            <PriceTag total={total} currency={currency} />
        </div>
    )
}

GroupCostLine.propTypes = {
    label: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired
}

export default GroupCostLine
